import { configureStore } from '@reduxjs/toolkit';

import { MiniGroup, Creature, Sheet, Settings } from './entities'

// store

export default configureStore({
  reducer: {
    groups: MiniGroup.reducer,
    creatures: Creature.reducer,
    sheets: Sheet.reducer,
    settings: Settings.reducer,
  },
});


// selectors

export const getCreatures = (state) => Creature.selectors.selectAll(state.creatures);
export const getSheets = (state) => Sheet.selectors.selectAll(state.sheets);

export const getCreatureById = (state, id) => Creature.selectors.selectById(state.creatures, id);
export const getGroupsOnSheet = (state, sheetId) => MiniGroup.selectors.selectAll(state.groups).filter(group => (group.sheetId === sheetId));
export const getSheetById = (state, id) => Sheet.selectors.selectById(state.sheet, id);

export const getSettings = (state) => Settings.selectors.selectAll(state.settings);
